import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { PdfContext } from 'utils/context';
import ObligationRestrictionTable from '../Tables/ObligationRestrictionTable';

const ObligationRestriction = () => {
  const { t } = useTranslation();
  const { obligationRestrictions, cultures, exploitation } = useContext(PdfContext);
  let arrangedObligationRestrictionData = [];

  let allObligationParcels = [];
  obligationRestrictions.forEach((obligationRestriction) => {
    let currentObligationParcels = obligationRestriction.Parcel_Id;
    allObligationParcels = [...allObligationParcels, ...currentObligationParcels];
  });

  let cleanedAllObligationParcelIds = [];
  allObligationParcels.forEach((parcelId) => {
    if (!cleanedAllObligationParcelIds.includes(parcelId)) {
      cleanedAllObligationParcelIds.push(parcelId);
    }
  });

  cleanedAllObligationParcelIds.forEach((parcelId) => {
    obligationRestrictions.forEach((obligationRestriction) => {
      if (
        obligationRestriction.Parcel_Id.includes(parcelId) &&
        !arrangedObligationRestrictionData.some(
          (obligationRestriction) => obligationRestriction.parcelId === parcelId,
        )
      ) {
        if (obligationRestriction.constraint === 'interdiction') {
          arrangedObligationRestrictionData.push({
            parcelId: parcelId,
            cultures: obligationRestriction.Exploitation_Culture_Id.map((cultureId) => ({
              cultureId: cultureId,
              obligation: [],
              restriction: [...obligationRestriction.years],
              division: [],
              permission: [],
            })),
          });
        }
        if (obligationRestriction.constraint === 'obligation') {
          arrangedObligationRestrictionData.push({
            parcelId: parcelId,
            cultures: obligationRestriction.Exploitation_Culture_Id.map((cultureId) => ({
              cultureId: cultureId,
              obligation: [...obligationRestriction.years],
              restriction: [],
              division: [],
              permission: [],
            })),
          });
        }
        if (obligationRestriction.constraint === 'division') {
          arrangedObligationRestrictionData.push({
            parcelId: parcelId,
            cultures: obligationRestriction.Exploitation_Culture_Id.map((cultureId) => ({
              cultureId: cultureId,
              obligation: [],
              restriction: [],
              division: [...obligationRestriction.years],
              permission: [],
            })),
          });
        }
        if (obligationRestriction.constraint === 'permission') {
          arrangedObligationRestrictionData.push({
            parcelId: parcelId,
            cultures: obligationRestriction.Exploitation_Culture_Id.map((cultureId) => ({
              cultureId: cultureId,
              obligation: [],
              restriction: [],
              division: [],
              permission: [...obligationRestriction.years],
            })),
          });
        }
        if (obligationRestriction.constraint === 'conversion') {
          arrangedObligationRestrictionData.push({
            parcelId: parcelId,
            constraint: 'conversion',
            year: obligationRestriction.year,
          });
        }
      } else if (
        obligationRestriction.Parcel_Id.includes(parcelId) &&
        arrangedObligationRestrictionData.some(
          (obligationRestriction) => obligationRestriction.parcelId === parcelId,
        )
      ) {
        let obligationToUpdate = arrangedObligationRestrictionData.find(
          (obligation) => obligation.parcelId === parcelId,
        );

        if (obligationRestriction?.Exploitation_Culture_Id) {
          obligationRestriction?.Exploitation_Culture_Id?.forEach((cultureId) => {
            if (obligationToUpdate.cultures.find((culture) => culture.cultureId === cultureId)) {
              let cultureToUpdate = obligationToUpdate.cultures.find(
                (culture) => culture.cultureId === cultureId,
              );
              if (obligationRestriction.constraint === 'obligation') {
                cultureToUpdate.obligation = [
                  ...cultureToUpdate.obligation,
                  ...obligationRestriction.years,
                ];
              }
              if (obligationRestriction.constraint === 'interdiction') {
                cultureToUpdate.restriction = [
                  ...cultureToUpdate.restriction,
                  ...obligationRestriction.years,
                ];
              }
              if (obligationRestriction.constraint === 'division') {
                cultureToUpdate.division = [
                  ...cultureToUpdate.division,
                  ...obligationRestriction.years,
                ];
              }
              if (obligationRestriction.constraint === 'permission') {
                cultureToUpdate.permission = [
                  ...cultureToUpdate.permission,
                  ...obligationRestriction.years,
                ];
              }
            } else {
              if (obligationRestriction.constraint === 'obligation') {
                obligationToUpdate.cultures.push({
                  cultureId: cultureId,
                  obligation: [...obligationRestriction.years],
                  restriction: [],
                  division: [],
                  permission: [],
                });
              }
              if (obligationRestriction.constraint === 'interdiction') {
                obligationToUpdate.cultures.push({
                  cultureId: cultureId,
                  obligation: [],
                  division: [],
                  restriction: [...obligationRestriction.years],
                  permission: [],
                });
              }
              if (obligationRestriction.constraint === 'division') {
                obligationToUpdate.cultures.push({
                  cultureId: cultureId,
                  obligation: [],
                  division: [...obligationRestriction.years],
                  restriction: [],
                  permission: [],
                });
              }
              if (obligationRestriction.constraint === 'permission') {
                obligationToUpdate.cultures.push({
                  cultureId: cultureId,
                  obligation: [],
                  division: [],
                  restriction: [],
                  permission: [...obligationRestriction.years],
                });
              }
            }
          });
        }
        if (obligationRestriction.constraint === 'conversion') {
          let foundObligationIndex = arrangedObligationRestrictionData.findIndex(
            (obligation) => obligation.parcelId === parcelId,
          );
          arrangedObligationRestrictionData[foundObligationIndex] = {
            ...arrangedObligationRestrictionData[foundObligationIndex],
            constraint: 'conversion',
            year: obligationRestriction.year,
          };
        }
      }
    });
  });

  arrangedObligationRestrictionData?.forEach((parcel) => {
    parcel.name = exploitation?.parcels?.find((parcelle) => parcelle?.id === parcel.parcelId)?.name;
    parcel?.cultures?.forEach((culture) => {
      culture.name = cultures.find((crop) => crop.id === culture.cultureId)?.name;
    });
  });

  let truncatedObligationRestriction = truncateObligationRestriction(
    arrangedObligationRestrictionData,
    16,
  );
  let obligationRestrictionPages = [];

  truncatedObligationRestriction.forEach((pageData, index) => {
    obligationRestrictionPages.push(
      <ObligationRestrictionTable
        key={index}
        truncatedObligationRestriction={pageData}
        messageDuplicate={index > 0 ? t('simulation.common.continued') : ''}
      />,
    );
  });

  return obligationRestrictionPages;
};

const truncateObligationRestriction = (obligationRestriction, numberOfRowPerTable) => {
  let slicedObligationRestriction = [];
  let tempObligationRestriction = [];
  let rowCounter = 0;
  obligationRestriction.map((parcel) => {
    rowCounter++;
    let parcelObject = { name: parcel.name, parcelId: parcel.parcelId, cultures: [] };
    if (rowCounter === numberOfRowPerTable) {
      rowCounter = 1;
      slicedObligationRestriction.push(tempObligationRestriction);
      tempObligationRestriction = [];
    }
    if (parcel?.constraint === 'conversion') {
      rowCounter += 3;
      tempObligationRestriction.push({
        ...parcelObject,
        constraint: 'conversion',
        year: parcel.year,
      });
      return;
    }
    parcel?.cultures?.map((culture) => {
      let cultureCounter = 0;
      if (
        culture.obligation.length > 0 &&
        culture.restriction.length > 0 &&
        culture.division.length > 0 &&
        culture.permission.length > 0
      ) {
        cultureCounter = 4;
      } else {
        cultureCounter = 1;
      }
      let cultureObject = {
        cultureId: culture.cultureId,
        name: culture.name,
        obligation: culture.obligation,
        restriction: culture.restriction,
        division: culture.division,
        permission: culture.permission,
      };
      if (rowCounter <= numberOfRowPerTable - 4) {
        rowCounter += cultureCounter;
        parcelObject.cultures.push(cultureObject);
      } else if (
        rowCounter > numberOfRowPerTable - 3 &&
        rowCounter < numberOfRowPerTable &&
        cultureCounter === 1
      ) {
        rowCounter += cultureCounter;
        parcelObject.cultures.push(cultureObject);
      } else if (
        rowCounter > numberOfRowPerTable - 3 &&
        rowCounter < numberOfRowPerTable &&
        cultureCounter > 1
      ) {
        let truncatedCultureObjectObligation = {
          cultureId: culture.cultureId,
          name: culture.name,
          obligation: culture.obligation,
          restriction: [],
          division: [],
          permission: [],
        };
        let truncatedCultureObjectRestriction = {
          cultureId: culture.cultureId,
          name: culture.name,
          obligation: [],
          restriction: culture.restriction,
          division: [],
          permission: [],
        };
        let truncatedCultureObjectDivision = {
          cultureId: culture.cultureId,
          name: culture.name,
          obligation: [],
          restriction: [],
          division: culture.division,
          permission: [],
        };
        let truncatedCultureObjectpermission = {
          cultureId: culture.cultureId,
          name: culture.name,
          obligation: [],
          restriction: [],
          division: [],
          permission: culture.permission,
        };
        parcelObject.cultures.push(truncatedCultureObjectObligation);
        rowCounter = 1;
        tempObligationRestriction.push(parcelObject);
        slicedObligationRestriction.push(tempObligationRestriction);
        tempObligationRestriction = [];
        parcelObject = { name: parcel.name, parcelId: parcel.parcelId, cultures: [], suite: true };
        if (culture.restriction.length > 0)
          parcelObject.cultures.push(truncatedCultureObjectRestriction);
        if (culture.division.length > 0) parcelObject.cultures.push(truncatedCultureObjectDivision);
        if (culture.permission.length > 0)
          parcelObject.cultures.push(truncatedCultureObjectpermission);
      } else {
        rowCounter = 1;
        tempObligationRestriction.push(parcelObject);
        slicedObligationRestriction.push(tempObligationRestriction);
        tempObligationRestriction = [];
        parcelObject = { name: parcel.name, parcelId: parcel.parcelId, cultures: [], suite: true };
        parcelObject.cultures.push(cultureObject);
      }
    });
    tempObligationRestriction.push(parcelObject);
  });

  slicedObligationRestriction.push(tempObligationRestriction);

  return slicedObligationRestriction;
};

export default ObligationRestriction;
